var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"normal-modal"},[_c('div',{staticClass:"normal-modal__video"},[_c('video',{attrs:{"controls":"controls","src":_vm.compVideoSrc}})]),_c('div',{staticClass:"normal-modal-btns"},[_c('div',{staticClass:"button",on:{"click":_vm.onDestroy}},[_vm._v("")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }